import { Location } from 'iconsax-react';
import Image from 'next/image';
import { useTheme } from 'styled-components';

import { useAddressContext } from '@/shared/contexts/AddressContext';
import { Button, Text } from '@develop-fapp/ui-kit-fapp';

import * as S from './styles';

export const Empty = () => {
  const { colors } = useTheme();

  const { setCurrentStep } = useAddressContext();

  return (
    <S.Wrapper>
      <Text variant="h5" weight="bold">
        Endereço não cadastrado
      </Text>
      <Image
        src="/static/images/address/empty_state.svg"
        alt="Imagem de cadastro de endereço"
        width={180}
        height={175}
      />
      <div>
        <Text variant="h8">
          Ainda não há endereços de entrega cadastrados, inclua sua região em
          Adicionar endereço.
        </Text>
      </div>
      <Button
        type="button"
        id="btn-add-address"
        variant="contained"
        startIcon={<Location size="18" color={colors.white} variant="Bold" />}
        onClick={() => setCurrentStep('search')}
      >
        Adicionar endereço
      </Button>
    </S.Wrapper>
  );
};
